import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export default function EventDescription() {
  return (
    <section
      id="event"
      data-testid="event-description-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {/* Image */}
          <motion.div
            className="md:col-span-5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://static.wixstatic.com/media/e20b0d97c6d24ccebb794dea7e942e18.jpg/v1/fill/w_800,h_1067,al_c,q_80,enc_avif,quality_auto/e20b0d97c6d24ccebb794dea7e942e18.jpg"
                alt="Champagne toast celebration"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            className="md:col-span-7"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }}
          >
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4 block font-['Outfit']">
              The Invitation
            </span>
            <h2 className="text-3xl md:text-5xl font-light tracking-tight leading-tight mb-8">
              An Evening Curated for Women Ready to Exhale
            </h2>
            <div className="space-y-5 text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75">
              <p>
                You're invited to an intimate evening curated for women who are ready to exhale,
                reconnect, and be poured into.
              </p>
              <p>
                Join Crystal Khalil and Dr. Nicole LaBeach of Sister Diamonds at SKYN CULTURE
                for a beautiful night of champagne, light bites, meaningful conversation, and
                connection as they share more about their upcoming Costa Rica Retreat.
              </p>
              <p>
                This gathering is designed for women who are always showing up for everyone else
                and are ready to explore what it looks like to make space for their own renewal,
                joy, and elevation.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
